dom = React.DOM
component = React.createElement
PropTypes = React.PropTypes
Motion = require('react-motion').Motion
spring = require('react-motion').spring
presets = require('react-motion').presets

IconSVG = require('svg-inline-react')

require('./style')

CheckBox = React.createClass({
  propTypes: {
  # this is required to associate the checkmark svg with the element
    id: PropTypes.string.isRequired
    checked: PropTypes.bool
    onChange: PropTypes.func
  }

  render: ->
    dom.div { className: 'CheckBox' },
      dom.input {
        type: 'checkbox'
        id: @props.id
        checked: @props.checked
        onChange: @props.onChange.bind(null, @props.id, not @props.checked) if @props.onChange
        disabled: @props.disabled
      }
      dom.label { htmlFor: @props.id },
        component IconSVG, { src: require('!svg-inline-loader?removeTags=true!./check.svg') } if @props.checked
})

module.exports = CheckBox



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/CheckBox/index.coffee